module.exports = __webpack_public_path__ + "img/Arty.dde074cf.png";